export const NEED_RSVP = 0;
export const GOING_RSVP = 1;
export const LIKED_RSVP = 2;
export const NOT_GOING_RSVP = 3;
export const PENDING_RSVP = 4;
export const INTERESTED_RSVP = 5;
